var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiaryEtbIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5E9F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C22.927 25 24.6734 25.7829 25.9404 27.0459C26.8094 26.3741 27.8791 26 29 26C31.757 26 34 28.243 34 31C34 31.552 33.553 32 33 32C32.447 32 32 31.552 32 31C32 29.346 30.654 28 29 28C28.317 28 27.6676 28.2344 27.1436 28.6494C27.6875 29.6454 28 30.7871 28 32C28 32.552 27.553 33 27 33C26.447 33 26 32.552 26 32C26 29.243 23.757 27 21 27C18.243 27 16 29.243 16 32C16 32.552 15.553 33 15 33C14.447 33 14 32.552 14 32C14 28.14 17.141 25 21 25ZM29 19C30.654 19 32 20.346 32 22C32 23.654 30.654 25 29 25C27.346 25 26 23.654 26 22C26 20.346 27.346 19 29 19ZM21 15C23.206 15 25 16.794 25 19C25 21.206 23.206 23 21 23C18.794 23 17 21.206 17 19C17 16.794 18.794 15 21 15ZM29 21C28.448 21 28 21.449 28 22C28 22.551 28.448 23 29 23C29.552 23 30 22.551 30 22C30 21.449 29.552 21 29 21ZM21 17C19.897 17 19 17.897 19 19C19 20.103 19.897 21 21 21C22.103 21 23 20.103 23 19C23 17.897 22.103 17 21 17Z",
    fill: "#661C69"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiaryEtbIcon);
export default __webpack_public_path__ + "static/media/beneficiaryEtbIcon.ede54deeaa0c590fd21b528c98f5b3b1.svg";
export { ForwardRef as ReactComponent };